import { render } from "./ChatChart.vue?vue&type=template&id=3fcf405e&scoped=true"
import script from "./ChatChart.vue?vue&type=script&lang=js"
export * from "./ChatChart.vue?vue&type=script&lang=js"

import "./ChatChart.vue?vue&type=style&index=0&id=3fcf405e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fcf405e"]])

export default __exports__